/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipment_Status_BookedInputs */

const en_shipment_status_booked = /** @type {(inputs: Shipment_Status_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked`)
};

/**
* | output |
* | --- |
* | "Booked" |
*
* @param {Shipment_Status_BookedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shipment_status_booked = /** @type {((inputs?: Shipment_Status_BookedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipment_Status_BookedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shipment_status_booked(inputs)
});